<!-- eslint-disable -->
<template>
  <CommonPages id="terms" :class="['terms-page']" :titlePrefix="'Terms of Service'"
    :metaDescription="domainConfig?.['meta']?.des || 'Terms of Service and conditions of use'">
    <div class="privacy-full">
      <div class="privacy-full__container">
        <div class="privacy-full__content">
          <h1 class="privacy-full__title">Terms of Service</h1>
          <div class="privacy-full__body">
            <div class="privacy-section">
              <p class="privacy-section__text">
                By using this website, you agree to the following terms and conditions. Please
                review them carefully
                before proceeding.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">1. Use of Services</h2>
              <p class="privacy-section__text">
                This website offers tools to generate names using artificial intelligence. You agree
                to use these tools
                responsibly and not for any unlawful or deceptive purposes.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">2. Intellectual Property</h2>
              <p class="privacy-section__text">
                All generated names, website content, and design elements are either owned by or
                licensed to us. You
                may use generated names for personal or commercial projects, but you may not copy or
                republish any
                portion of the website or its underlying technology.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">3. No Guarantee of Uniqueness</h2>
              <p class="privacy-section__text">
                Names generated by our AI are based on patterns and data models and are not
                guaranteed to be unique or
                legally available for use (e.g., trademarks, domains, or official registrations).
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">4. Account Usage</h2>
              <p class="privacy-section__text">
                If account creation is available, you are solely responsible for maintaining access
                credentials and
                ensuring your activities comply with these terms.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">5. Service Updates</h2>
              <p class="privacy-section__text">
                We reserve the right to update, modify, or suspend the website or its features at
                any time, without
                prior notice.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">6. Liability Limitations</h2>
              <p class="privacy-section__text">
                We are not responsible for any outcomes, damages, or losses resulting from the use
                of generated names,
                whether for branding, legal, or personal purposes.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">7. Legal Jurisdiction</h2>
              <p class="privacy-section__text">
                These terms are governed by the applicable laws of the region in which the website
                operates.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'

import '@/css/common.scss';

export default {
  name: 'Terms',
  components: {
    CommonPages
  },
  mixins: [common, adMixin, adTrackingMixin],
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
    ]),
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Terms] Component activated`);
    }
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Terms] Component mounted`);
    }
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Terms] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Terms] Component beforeDestroy`);
    }
  },
  methods: {

  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.privacy-full {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	width: 100%;
	margin: 0 0 rem(88);

	&__container {
		width: 100%;
		position: relative;
	}

	&__content {
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: flex-start;
		justify-content: flex-start;
		padding: rem(88) rem(180);
		position: relative;
		z-index: 1;
	}

	&__title {
		color: #1a4048;
		font-size: rem(24);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: 0;
	}

	&__body {
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		align-self: stretch;
	}
}

.privacy-section {
	display: flex;
	flex-direction: column;
	gap: rem(16);
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;
	align-self: stretch;

	&__title {
		color: #1a4048;
		font-size: rem(18);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: 0;
	}

	&__subtitle {
		color: #1a4048;
		font-size: rem(16);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: rem(8) 0;
	}

	&__text {
		color: #1a4048;
		text-align: left;
		font-size: rem(16);
		line-height: rem(28);
		font-weight: 400;
		margin: rem(8) 0;
	}

	&__link {
		color: #1a4048;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	&__list,
	&__numbered-list {
		color: #1a4048;
		padding-left: rem(24);
		margin: rem(8) 0;

		li {
			margin-bottom: rem(10);
			line-height: rem(28);
			font-size: rem(16);

			strong {
				color: #1a4048;
				font-weight: 500;
				display: block;
				margin-bottom: rem(4);
			}
		}
	}

	&__numbered-list {
		counter-reset: section;
		list-style-type: none;
		padding-left: 0;

		> li {
			margin-bottom: rem(24);
			padding-left: rem(24);
			position: relative;

			&:before {
				counter-increment: section;
				content: counter(section) '.';
				position: absolute;
				left: 0;
				color: #1a4048;
				font-weight: 500;
			}
		}
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.privacy-full {
		// PC端特定样式
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.privacy-full {
		&__content {
			width: 100%;
			padding: rem(40) rem(16);
		}

		&__title {
			font-size: rem(20);
			line-height: rem(20);
		}
	}

	.privacy-section {
		&__title {
			font-size: rem(16);
			line-height: rem(20);
		}

		&__subtitle {
			font-size: rem(14);
			line-height: rem(20);
		}

		&__text {
			font-size: rem(14);
			line-height: rem(24);
		}

		&__list,
		&__numbered-list {
			li {
				font-size: rem(14);
				line-height: rem(24);
			}
		}
	}
}
</style> 